const INSTAGRAM_URL = "https://www.instagram.com/benthos.ai/";
const YOUTUBE_URL =
  "https://www.youtube.com/playlist?list=PLN6dUbUeFaLXeTgxm5grKjV33RhfT91Wi";
const WEBSITE_URL = "https://benthos.ai";

export { INSTAGRAM_URL, YOUTUBE_URL, WEBSITE_URL };
